<div *ngIf="html" class="personalized-email__layer">
  <table class="personalized-email__wrapper" cellpadding="0" cellspacing="0" border="0" align="center">
    <tbody>
      <tr>
        <td>
          <table class="personalized-email__header" cellpadding="0" cellspacing="0" border="0" align="center">
            <tr>
              <td>
                <img
                  src="https://min.gamelearn.io/css-resources/email-templates/logo-gamelearn.png"
                  alt="gamelearn"
                  class="personalized-email__logo"
                />
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <table class="notifications__template" cellpadding="0" cellspacing="0" border="0" align="center">
            <tr>
              <td>
                <div class="personalized-email__image"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="personalized-email__text" [innerHTML]="html"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="personalized-email__legend">
                  {{ personalizedLegend }}
                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td>
          <table class="personalized-email__footer" cellpadding="0" cellspacing="0" border="0" align="center">
            <tr>
              <td>
                <img
                  src="https://min.gamelearn.io/css-resources/email-templates/logo-gamelearn.png"
                  alt="gamelearn"
                  class="personalized-email__footer--logo"
                />
              </td>
            </tr>
            <tr>
              <td>
                <p class="personalized-email__footer--text" mc:edit="footer_social">{{ followUs }}</p>
                <div class="personalized-email__footer--social">
                  <a href="https://www.facebook.com/Gamelearn" target="_blank" class="facebook"></a>
                  <a href="https://www.linkedin.com/company/Gamelearn" target="_blank" class="linkedin"></a>
                  <a href="https://twitter.com/gamelearn" target="_blank" class="twitter"></a>
                  <a
                    href="https://www.youtube.com/channel/UCtZ_DvQSnRsE1j4oPQH9Qfw"
                    target="_blank"
                    class="youtube"
                  ></a>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="personalized-email__footer--list__centered">
                  <div class="personalized-email__footer--list">
                    <span
                      ><a href="{{ faqHref }}">{{ faq }}</a></span
                    >
                    <span class="personalized-email__separator"></span>
                    <span
                      ><a href="{{ contactHref }}">{{ contact }}</a></span
                    >
                    <span class="personalized-email__separator"></span>
                    <span
                      ><a href="{{ aboutUsHref }}">{{ aboutUs }}</a></span
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="personalized-email__footer--legend">
                  {{ address }}
                </div>
                <div class="personalized-email__footer--legend" [innerHtml]="contactLink"></div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>
